export default (value) => {
  let fixed = (Number(value) / 100).toFixed(2).replace('.', ',')

  return `${fixed}`
};